import { Component, Input, OnChanges } from '@angular/core';

import { User } from 'app/models';

@Component({
  standalone: false,
  selector: 'app-user-photo',
  templateUrl: './user-photo.component.html',
  styleUrls: ['./user-photo.component.scss']
})
export class UserPhotoComponent implements OnChanges {
  @Input()
  user: User;
  @Input() bordercss: boolean;
  @Input() image: string;
  @Input() size = '72px';

  userInitials: string;

  ngOnChanges() {
    if (this.user) {
      this._parseName();
    }
  }

  private _parseName() {
    if (!this.user.name) {
      return;
    }

    const splitName = this.user.name.split(' ').filter(st => st.length > 0);
    if (splitName.length > 1) {
      this.userInitials = `${splitName[0][0].toUpperCase()}${splitName[1][0].toUpperCase()}`;
    } else {
      this.userInitials = splitName[0][0].toUpperCase();
    }
  }
}
